const actionType = {
    GET_ADJUSTMENT_CONFIGURATION_SUCCESS: 'GET_ADJUSTMENT_CONFIGURATION_SUCCESS',
    GET_ADJUSTMENT_CONFIGURATION_FAILURE: 'GET_ADJUSTMENT_CONFIGURATION_FAILURE',
    GET_WORKFLOW_RULE_NAME_RULE_SUCCESS: 'GET_WORKFLOW_RULE_NAME_RULE_SUCCESS',
    GET_WORKFLOW_CONFIGURATION_SUCCESS: 'GET_WORKFLOW_CONFIGURATION_SUCCESS',
};
export default actionType;
